import { render } from "./TestArea.vue?vue&type=template&id=683a5978&scoped=true"
import script from "./TestArea.vue?vue&type=script&lang=js"
export * from "./TestArea.vue?vue&type=script&lang=js"

import "./TestArea.vue?vue&type=style&index=0&id=683a5978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683a5978"]])

export default __exports__